<app-tab-generic
[componentsData]="componentsData"
></app-tab-generic>
